// Minimal Bahasa Malaysia locale — ships translations for the Voice
// section only (Overview + Playground + sidebar entry). Every other
// key falls back to English via vue-i18n's `fallbackLocale: 'en'`
// configured in entrypoints/dashboard.js, so missing keys render
// English copy rather than the raw key path.
//
// Add more JSON files here as the surface gets translated.
import voiceCall from './voiceCall.json';
import settings from './settings.json';

export default {
  ...voiceCall,
  ...settings,
};
